<template>
  <div class="addmember">
    <div v-if="init">
      <div class="title">
        添加组员
        <p></p>
      </div>

      <div class="table_div">
        <div class="header">
          <div class="h_left">
            团队成员：(
            <span>2</span>人)
          </div>
          <div class="h_right">
            <el-button class="add" @click="addMember">添加团队成员</el-button>
            <el-button class="download" ref="download" @click="downloadExail">下载列表</el-button>
          </div>
        </div>

        <div class="table_">
          <el-table
            :header-cell-style="{background: '#f2f2f2',color: '#333333',fontSize: '14px'}"
            :row-style="{height: '52px'}"
            border
            :data="realtimeList"
          >
            <el-table-column
              header-align="center"
              align="center"
              width="174"
              label="组员姓名"
              prop="name"
            ></el-table-column>
            <el-table-column header-align="center" align="center" width="174" label="职务" prop="job"></el-table-column>
            <el-table-column header-align="center" align="center" width="174" label="称谓" prop="sex"></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              width="173"
              label="手机"
              prop="telephone"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              width="174"
              label="邮箱"
              prop="email"
            ></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <!-- 新增 -->
    <div class="addPage" v-else>
      <div class="title">添加组员 > 添加团队成员</div>
      <el-button class="newAdd" @click="newAdd">新增成员</el-button>
      <div class="info_div" v-for="(item,index) in memberList" :key="index">
        <div class="top">
          同事*
          <span>{{ index + 1 }}</span>
        </div>
        <el-form class="addPage_form" ref="dataForm" :rules="rules" :model="item">
          <el-form-item label="称谓：" label-width="169px" prop="sex">
            <el-radio v-model="item.sex" label="0">先生</el-radio>
            <el-radio v-model="item.sex" label="1">女士</el-radio>
          </el-form-item>

          <el-form-item label="姓名：" label-width="169px" prop="name" class="maxWidth_item">
            <el-input v-model="item.name" placeholder="请填写姓名"></el-input>
          </el-form-item>

          <el-form-item label="职位：" label-width="140px" prop="job" class="maxWidth_item">
            <el-input v-model="item.job" placeholder="请填写您的职务"></el-input>
          </el-form-item>

          <el-form-item label="手机号码：" label-width="169px" prop="telephone" class="maxWidth_item">
            <el-input v-model="item.telephone" placeholder="请填写您的手机号"></el-input>
          </el-form-item>

          <el-form-item label="邮箱：" label-width="140px" prop="email" class="maxWidth_item">
            <el-input v-model="item.email" placeholder="请填写您的邮箱"></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div class="button_btns">
        <el-button @click="saveInfo">查看成员信息</el-button>
        <el-button @click="submitInfo">提交信息</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    //手机号校验规则
    let mobileValidata = (rule, value, callback) => {
      let testStr = /^1[0-9]{10}$/;
      if (value === "") {
        callback(new Error("请输入手机号码"));
      } else if (!testStr.test(value)) {
        callback(new Error("请输入正确的手机号码!"));
      } else {
        callback();
      }
    };
    return {
      realtimeList: [],
      init: true,
      radio: "0",
      form: {
        mame: "",
        sex: "",
        job: "",
        email: "",
        telephone: "",
      },
      rules: {
        name: [{ required: true, message: "*为必填项", trigger: "blur" }], // validator 校验规则
        telephone: [{ required: true, validator: mobileValidata, trigger: "blur" }],
        sex: [{ required: true, message: "*为必填项", trigger: "blur" }],
        email: [{ required: true, message: "*为必填项", trigger: "blur" }],
        job: [{ required: true, message: "*为必填项", trigger: "blur" }],
      },

      // 新增成员
      memberList: [
        {
          sex: "0",
          name: "",
          job: "",
          telephone: "",
          email: "",
        },
      ],
    };
  },
  mounted() {
    this.getAllMember();
  },
  methods: {
    // 所有组员
    getAllMember() {
      this.$http({
        url: "viewer/getViewerGroupListByViewer",
        method: "get",
      })
        .then(({ data }) => {
          let { code, viewerGroupList } = data;
          if (code === 0) {
            viewerGroupList.forEach((ele) => {
              ele.sex = ele.sex === "0" ? "先生" : "女士";
            });
            this.realtimeList = viewerGroupList;
          } else {
            this.$message.error("登录失效，请重新登录");
            this.$router.push("/audLogin");
          }
        })
        .catch((err) => {
          this.$message.error("登录失效，请重新登录");
          this.$router.push("/audLogin");
        });
    },

    // 添加团队成员
    addMember() {
      this.init = false;
    },
    // 下载
    downloadExail() {
      this.$http({
        url: "viewer/exportExcel",
        method: "get",
        responseType: "arraybuffer",
      }).then(({ data }) => {
        let blob = new Blob([data], { type: "application/vnd.ms-excel" });
        let objectUrl = URL.createObjectURL(blob);
        const elink = document.createElement("a");
        elink.download = "成员列表.xls";
        elink.style.display = "none";
        elink.href = objectUrl;
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
      });
    },
    // 新增成员
    newAdd() {
      let memObj = {
        sex: "0",
        name: "",
        job: "",
        telephone: "",
        email: "",
      };
      this.memberList.push(memObj);
    },
    // 提交信息
    submitInfo() {
      this.$http({
        url: "viewer/saveViewerGroupByViewer",
        method: "post",
        data: this.$http.adornData({
          viewerGroups: JSON.stringify(this.memberList),
        }),
      })
        .then(({ data }) => {
          let { code } = data;
          if (code === 0) {
            this.$message({
              message: "添加成功！",
              type: "success",
              duration: 1000,
              onClose: () => {
                this.getAllMember();
              },
            });
          } else {
            this.$message.error("请填写所有必填项");
          }
        })
        .catch((err) => console.log(err));
    },
    // 查看成员信息
    saveInfo() {
      this.init = true;
    },
  },
};
</script>
<style lang="scss">
.addmember {
  .el-table--border th,
  .el-table--border td {
    border-right: 1px solid #e5e5e5;
  }
}
</style>
<style lang="scss">
.addmember {
  .el-input {
    width: 240px;
  }
  .el-input__inner {
    width: 240px;
    height: 42px;
    border-radius: 4px;
  }
  .el-radio {
    width: 70px;
  }
  .el-radio__inner {
    &:hover {
      border-color: #143372;
    }
  }
  .el-radio__input .el-radio__inner {
    width: 20px;
    height: 20px;
  }
  .el-radio__input.is-checked .el-radio__inner {
    width: 20px;
    height: 20px;
    background-color: #ffffff;
    border: 2px solid #dcdfe6;
    border-color: #143372;
  }
  .el-radio__inner::after {
    width: 12px;
    height: 12px;
    background-color: #143372;
  }
  .el-radio__input.is-checked + .el-radio__label {
    color: #333333;
  }
  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before,
  .el-form-item.is-required:not(.is-no-asterisk)
    .el-form-item__label-wrap
    > .el-form-item__label:before {
    margin-right: 25px;
  }
}
</style>
<style lang="scss" scoped>
.addmember {
  .title {
    width: 100%;
    height: 66px;
    line-height: 66px;
    font-size: 18px;
    color: #143372;
    position: relative;
    border-bottom: 1px solid #e5e5e5;
    text-indent: 30px;
    margin-bottom: 10px;
    p {
      width: 70px;
      height: 2px;
      background-color: #143372;
      position: absolute;
      bottom: -1px;
      left: 30px;
    }
  }
  .table_div {
    padding: 0 20px 50px 30px;
    .header {
      height: 38px;
      line-height: 38px;
      margin: 8px 0 17px 0;
      .h_left {
        width: 200px;
        float: left;
        color: #143372;
        font-size: 14px;
      }
      .h_right {
        width: 240px;
        float: right;
        .el-button {
          height: 38px;
          background-color: #143372;
          color: #ffffff;
          font-size: 14px;
        }
        .add {
          width: 124px;
        }
        .download {
          width: 102px;
          margin-left: 14px;
        }
      }
    }
  }
  .addPage {
    .newAdd {
      width: 100px;
      height: 34px;
      background-color: #ff6600;
      color: #ffffff;
      font-size: 14px;
      line-height: 0;
      border-radius: 2px;
      margin: 9px 0 19px 30px;
      &:focus {
        border-color: #ff6600;
      }
    }
    .maxWidth_item {
      width: 420px;
      float: left;
    }
    .top {
      font-size: 18px;
      color: #333333;
      margin: 20px 0 30px 29px;
    }
    .info_div {
      width: 860px;
      height: 300px;
      border: 1px solid #e5e5e5;
      border-radius: 10px;
      margin: 0 auto 20px;
    }
  }
  .button_btns {
    text-align: right;
    margin: 20px 31px 44px 0;
    button {
      height: 36px;
      font-size: 14px;
      line-height: 0;
    }
    button:first-child {
      width: 124px;
      background-color: #ffffff;
      color: #143372;
      border-color: #143372;
      &:hover,
      &:focus {
        background-color: #ffffff;
        color: #143372;
      }
    }
    button:last-child {
      width: 102px;
      background-color: #143372;
      color: #ffffff;
    }
  }
}
</style>